import { Modal } from 'components';
import { FC, useState } from 'react';

import ModalContentStyled from './styles';

const ModalScheduleConfirmation: FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const cancelButton = {
    text: 'キャンセル',
    onClick: () => setIsModalVisible(false),
  };
  const okButton = { text: '確定', onClick: () => setIsModalVisible(false) };
  return (
    <>
      <button onClick={() => setIsModalVisible(true)}>Open modal ModalScheduleConfirmation</button>
      <Modal
        visible={isModalVisible}
        title="現場の予定期間を超えている作業員がいます"
        okButton={okButton}
        cancelButton={cancelButton}
        width={640}
      >
        <ModalContentStyled>
          確定すると遅延連絡が工事担当者に通知されます。予定を確定しますか？
        </ModalContentStyled>
      </Modal>
    </>
  );
};

export default ModalScheduleConfirmation;
